import { colors } from 'baseui/tokens';
import { capitalize, string2money } from 'common/utils/string';
import Text from 'components/elements/text';
import { GuestContent } from 'legacy-modules/order/cruise/components/summary/styles';
import { AirlineContainer } from 'legacy-modules/order/ticket-order/components/summary/styles';
import {
  FullContainer,
  SeparatorHorizontal,
  SeparatorVertical,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import { TourSaleItemFormType } from '../form-type';

interface Props {
  parentIdx: number;
  data: TourSaleItemFormType;
}

export default function SummaryItem(props: Props) {
  const { data } = props;
  const { t } = useTranslation();
  return (
    <div>
      {data.tourSaleGuests.map((guest) => {
        const title = [
          guest?.guestName,
          capitalize(guest.bedType),
          guest?.groupNumber ? `Group ${guest?.groupNumber}` : '',
        ]
          .filter(Boolean)
          .join(' | ');

        const description = [capitalize(guest?.type), guest?.flightName]
          .filter(Boolean)
          .join(' | ');

        return (
          <AirlineContainer key={guest.customId}>
            <FullContainer>
              <FullContainer>
                <Text variant="body1Bold">{title}</Text>
                <SeparatorVertical $margin={8} />
              </FullContainer>

              <FullContainer
                $style={{
                  display: 'flex',
                  marginTop: '8px',
                  marginBottom: '8px',
                  justifyContent: 'space-between',
                  paddingLeft: '24px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flex: 1,
                    gap: 8,
                  }}
                >
                  <Text variant="LabelSmall">{description}</Text>
                  <Text variant="LabelSmall" $style={{ color: colors.gray500 }}>
                    {`@ Rp ${string2money(guest.price || 0)}`}
                  </Text>
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <Text variant="LabelSmall">
                    {`Rp ${string2money(guest.price || 0)}`}
                  </Text>
                </div>
                <SeparatorVertical $margin={8} />
              </FullContainer>
            </FullContainer>
          </AirlineContainer>
        );
      })}
      {!!data.tourSaleAddOns.length && (
        <>
          <SeparatorVertical $margin={36} />
          <Text variant="ParagraphSmall" color={colors.gray500}>
            {t('ticketSales:add_ons')}
          </Text>
        </>
      )}
      {data.tourSaleAddOns.map((guest) => (
        <React.Fragment key={guest.customId}>
          <AirlineContainer>
            <GuestContent>
              <Text variant="LabelSmall">
                {`${guest.guestName || '-'} | ${guest.description || '-'}` ||
                  ''}
              </Text>
              <SeparatorHorizontal $margin={8} />
              <Text variant="LabelSmall" $style={{ color: colors.gray500 }}>
                {`@ Rp ${string2money(guest.price || 0)}`}
              </Text>
            </GuestContent>
            <Text variant="LabelSmall">
              {`Rp ${string2money(guest.price || 0)}`}
            </Text>
          </AirlineContainer>
        </React.Fragment>
      ))}
    </div>
  );
}
